<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed } from "vue";

const props = defineProps<{
  color?: string;
  borderColor?: string;
  padding?: string;
  margin?: string;
}>();
const styleObj = computed(() => ({
  color: props.color,
  borderColor: props.borderColor,
  padding: props.padding,
  margin: props.margin,
}));
</script>
<template>
  <nut-divider v-bind="$attrs" :style="styleObj" />
</template>
